export function seo(data = {}) {
  const isInvoiage = process.env.REACT_APP_MODE === 'invoiage';

  data.title = isInvoiage ? data.title : `${data.title} | EnergyPrint`;

  data.metaDescription = data.metaDescription || 
    (isInvoiage 
      ? 'Parse documents into structured data with ease' 
      : 'Utility Data Entry and Analytics');

  document.title = data.title;
  document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
}
